import { TYPES } from "./login.types";

const initState = {
  error: "",
  loading: false,
};

const loginReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.LOGIN_LOADING:
      return {
        ...state,
        loading: true,
      };
    case TYPES.LOGIN_SUCCESS:
      return {
        ...state,
        error: "",
        loading: false,
      };
    case TYPES.LOGIN_FAILED:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default loginReducer;
